import { render, staticRenderFns } from "./ReserveTransfersIntermediateServersTable.vue?vue&type=template&id=3a194a88&"
import script from "./ReserveTransfersIntermediateServersTable.vue?vue&type=script&lang=js&"
export * from "./ReserveTransfersIntermediateServersTable.vue?vue&type=script&lang=js&"
import style0 from "./ReserveTransfersIntermediateServersTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports